import React, { useState, useEffect } from 'react';
import { MdEmail, MdClose, MdSend } from 'react-icons/md';
import './EmailInputDialog.css';

const EmailInputDialog = ({ isOpen, onClose, onConfirm, title, message, confirmText = 'Invia', cancelText = 'Annulla' }) => {
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');

  useEffect(() => {
    if (isOpen) {
      setEmail('');
      setError('');
    }
  }, [isOpen]);

  const handleConfirm = () => {
    if (!email.trim()) {
      setError('Inserisci un indirizzo email');
      return;
    }

    if (!email.includes('@') || !email.includes('.')) {
      setError('Inserisci un indirizzo email valido');
      return;
    }

    onConfirm(email);
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      handleConfirm();
    }
  };

  if (!isOpen) return null;

  return (
    <div className="email-input-dialog-overlay" onClick={onClose}>
      <div className="email-input-dialog" onClick={(e) => e.stopPropagation()}>
        <div className="email-input-dialog-header">
          <div className="email-input-dialog-icon-wrapper">
            <MdEmail className="email-input-dialog-icon" />
          </div>
          <button
            className="email-input-dialog-close"
            onClick={onClose}
            title="Chiudi"
          >
            <MdClose />
          </button>
        </div>
        
        <div className="email-input-dialog-content">
          {title && (
            <h3 className="email-input-dialog-title">{title}</h3>
          )}
          {message && (
            <p className="email-input-dialog-message">{message}</p>
          )}
          
          <div className="email-input-dialog-field">
            <label className="email-input-dialog-label">
              Indirizzo Email *
            </label>
            <div className="email-input-dialog-input-wrapper">
              <MdEmail className="email-input-dialog-input-icon" />
              <input
                type="email"
                className="email-input-dialog-input"
                value={email}
                onChange={(e) => {
                  setEmail(e.target.value);
                  setError('');
                }}
                onKeyPress={handleKeyPress}
                placeholder="esempio@email.com"
                autoFocus
              />
            </div>
            {error && (
              <p className="email-input-dialog-error">{error}</p>
            )}
          </div>
        </div>

        <div className="email-input-dialog-actions">
          <button
            className="email-input-dialog-btn email-input-dialog-btn-cancel"
            onClick={onClose}
          >
            {cancelText}
          </button>
          <button
            className="email-input-dialog-btn email-input-dialog-btn-confirm"
            onClick={handleConfirm}
          >
            <MdSend />
            {confirmText}
          </button>
        </div>
      </div>
    </div>
  );
};

export default EmailInputDialog;
